import { actionTypes, acceptanceCreationSteps } from '../constants';

const createInitialState = () => ({
  step: acceptanceCreationSteps.addressesSetup,
});

export const reducer = (state = createInitialState(), action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.createReset: {
      return createInitialState();
    }

    case actionTypes.createStepChanged:
      return { ...state, step: payload };

    default: {
      return state;
    }
  }
};
